import React from "react";

export default function PaymentSelect({
    enabledValues = [],
    value = "",
    onChange,
    placeholder = "Selecione um método...",
    className = ""
}) {
    const CARD_FLAGS = ["Visa", "Mastercard", "Elo", "Amex", "Outro"];

    const currentMethod = value?.split("/")?.[0] || "";
    const currentFlag = value?.split("/")?.[1] || "";

    const requiresFlag = currentMethod === "CREDITO" || currentMethod === "DEBITO";

    const options = React.useMemo(() => {
        const PAYMENT_LABELS = {
            "CREDITO FOODZ": "Crédito Foodz",
            "DINHEIRO": "Dinheiro",
            "PIX": "PIX",
            "VA | VR": "VA | VR",
            "CREDITO": "Cartão Crédito",
            "DEBITO": "Cartão Débito"
        };

        return enabledValues.map(v => ({
            value: v,
            label: PAYMENT_LABELS[v] || v
        }));
    }, [enabledValues]);

    const handleMethodChange = (method) => {
        if (!method) return;

        if (method === "CREDITO" || method === "DEBITO") {
            onChange(`${method}/`);
        } else {
            onChange(method);
        }
    };

    const handleFlagChange = (flag) => {
        if (!currentMethod) return;
        onChange(`${currentMethod}/${flag.toUpperCase()}`);
    };

    return (
        <div className={`flex flex-col gap-2 ${className}`}>

            <select
                className="p-2 rounded-md bg-white shadow-md border border-slate-200
                           focus:border-indigo-500 focus:ring focus:ring-indigo-200
                           text-sm xl:text-base"
                value={currentMethod}
                onChange={(e) => handleMethodChange(e.target.value)}
            >
                <option value="" disabled>{placeholder}</option>

                {options.map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>

            {requiresFlag && (
                <select
                    className="p-2 rounded-md bg-white shadow-md border border-slate-200
                               focus:border-indigo-500 focus:ring focus:ring-indigo-200
                               text-sm xl:text-base"
                    value={currentFlag}
                    onChange={(e) => handleFlagChange(e.target.value)}
                >
                    <option value="" disabled>Selecione a bandeira...</option>

                    {CARD_FLAGS.map(flag => (
                        <option key={flag} value={flag}>
                            {flag}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
}
